var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-sheet',{attrs:{"inset":"","max-width":"400px","scrollable":""},model:{value:(_vm.feedbackStore.feedback),callback:function ($$v) {_vm.$set(_vm.feedbackStore, "feedback", $$v)},expression:"feedbackStore.feedback"}},[_c('FeedbackCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }